import { Flex, Stack, Text } from "@chakra-ui/react";
import Heading from "../Heading";
import RandomUserCard from "./RandomUserCard";

function RandomUsers({
  traders,
  setSelectedUser,
  setBtnLoading,
  handleNotInterested,
  handleFollow,
  acctType,
  setRefresh,
}) {
  return (
    <Stack spacing={"20px"} w="100%">
      <Heading textAlign={["center", "left"]} mt="20px" w="100%">
        {" "}
        Random Users
      </Heading>
      <Flex
        flexDirection={"row"}
        alignItems={"center"}
        flexWrap={"wrap"}
        gap="40px"
        justifyContent={["center", "flex-start"]}
      >
        {traders?.length > 1 ? (
          traders?.map((user) => {
            return (
              <RandomUserCard
                user={user}
                key={user?.id}
                setSelectedUser={setSelectedUser}
                acctType={acctType}
                setBtnLoading={setBtnLoading}
                handleNotInterested={handleNotInterested}
                handleFollow={handleFollow}
                setRefresh={setRefresh}
              />
            );
          })
        ) : (
          <Text fontSize={".9em"} color="grey">
            Currently not available
          </Text>
        )}
      </Flex>
    </Stack>
  );
}

export default RandomUsers;
